import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/client';
import logo from '../logo.png';
import BracketView from '../components/BracketView';
import FitToScreen from '../components/FitToScreen';

const POLL_INTERVAL = 5000; // ms — client-driven refresh, no reload needed by signage software

export default function BracketShow() {
  const { id } = useParams();
  const [tournament, setTournament] = useState(null);
  const [matches, setMatches] = useState([]);
  const [teams, setTeams] = useState([]);
  const [roundNotes, setRoundNotes] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const load = () => {
      api.get(`/api/tournaments/${id}/bracket`).then((r) => {
        if (cancelled) return;
        setTournament(r.data.tournament);
        setMatches(r.data.matches || []);
        setTeams(r.data.teams || []);
        setRoundNotes(r.data.round_notes || []);
      }).catch(() => {});
    };

    load();
    const interval = setInterval(load, POLL_INTERVAL);
    return () => { cancelled = true; clearInterval(interval); };
  }, [id]);

  return (
    <div className="fixed inset-0 bg-ocean-950 flex flex-col overflow-hidden select-none">
      {/* Turniername */}
      <div className="flex-shrink-0 flex items-center justify-center text-center" style={{ padding: 'clamp(12px, 3vh, 36px) clamp(16px, 4vw, 60px) clamp(6px, 1.5vh, 16px)' }}>
        <h1
          className="text-sand-300 font-black uppercase tracking-widest drop-shadow-lg"
          style={{ fontSize: 'clamp(1.4rem, 4.2vh, 3.4rem)' }}
        >
          {tournament?.name || ' '}
        </h1>
      </div>

      {/* Turnierbaum — komplett auf den Bildschirm skaliert */}
      <div className="flex-1 min-h-0" style={{ padding: '0 clamp(16px, 3vw, 48px) clamp(90px, 14vh, 160px) clamp(90px, 10vw, 160px)' }}>
        {!matches.length ? (
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-white/30 text-xl tracking-widest uppercase">Bracket noch nicht generiert</p>
          </div>
        ) : (
          <FitToScreen>
            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <BracketView
                tournament={tournament}
                matches={matches}
                teams={teams}
                roundNotes={roundNotes}
                onMatchClick={() => {}}
                hideLegend
              />
            </div>
          </FitToScreen>
        )}
      </div>

      {/* Logo unten links */}
      <img
        src={logo}
        alt="BeachLAN"
        className="absolute object-contain drop-shadow-lg opacity-90"
        style={{ left: 'clamp(16px, 3vw, 40px)', bottom: 'clamp(12px, 2.5vh, 32px)', height: 'clamp(40px, 8vh, 96px)', width: 'auto' }}
      />
    </div>
  );
}
